module.exports = __webpack_public_path__ + "img/CCR-5.13a062a4.png";